import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, HostBinding,
  HostListener,
  Input,
  OnInit,
  Output, QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

@Component({
  selector: 'tdo-list',
  templateUrl: './tdo-list.component.html',
  styleUrls: ['./tdo-list.component.scss']
})
export class TdoListComponent implements OnInit, AfterViewInit {
  @ViewChild('cont') container: ElementRef | undefined;
  @ViewChildren('el') listItems: QueryList<ElementRef> | undefined;
  @Input() dataSource: any[] = [];
  @Input() propertyName: string = '';
  @Input() isAutoFocus: boolean = true;
  @Input() isRequireFocus: boolean = true;

  @Input() staticStyle: any = {backgroundColor: '#f1f1f1'};

  @Output() onItemSelected: EventEmitter<any> = new EventEmitter<any>();

  index = 0;
  selectedItem: any;
  inputString = '';
  clearTimer: any;
  host: ElementRef | undefined;
  isFocused: boolean = false;
  selectedIndex = 0;

  @HostBinding('tabindex') tabindex = 0;
  @HostListener('focusin')
  focusInHandler() {
    this.isFocused = true;
    this.host?.nativeElement?.focus();
  }
  @HostListener('blur')
  focusHandler() {
    this.isFocused = false;
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.isFocused && this.isRequireFocus) {
      return;
    }

    if (String.fromCharCode(event.keyCode).match(/(\w|\s)/g) && event.key !== 'Enter' && event.key !== 'Tab') {
      if (this.clearTimer) {
        clearTimeout(this.clearTimer);
      }

      this.inputString += event.key.toLowerCase();
      this.selectedItem = this.dataSource.find(p => (p[this.propertyName] as string).toLowerCase().includes(this.inputString));
      this.selectedIndex = this.dataSource.findIndex(p => (p[this.propertyName] as string).toLowerCase().includes(this.inputString));
      const item = this.listItems?.find(p => p.nativeElement.innerText === this.selectedItem[this.propertyName]);
      item?.nativeElement.scrollIntoView();
      // this.container?.nativeElement?.scrollTo(item?.nativeElement.yPosition);
      this.clearTimer = setTimeout(() => {
        this.inputString = '';
      }, 400);
    } else {
      if (event.key === 'Shift' || event.key === 'Tab') {
        return;
      }
      else if (event.key === 'Enter') {
        if (this.selectedItem) {
          this.onItemSelected.emit(this.selectedItem);
        }
      } else if (event.key === 'ArrowDown') {
        if (this.selectedIndex === this.dataSource.length - 1) {
          this.selectedIndex = 0;
        } else {
          this.selectedIndex++;
        }
        this.selectedItem = this.dataSource[this.selectedIndex];
        const item = this.listItems?.find(p => p.nativeElement.innerText === this.selectedItem[this.propertyName]);
        item?.nativeElement.scrollIntoView();
      } else if (event.key === 'ArrowUp') {
        if (this.selectedIndex === 0) {
          this.selectedIndex = this.dataSource.length - 1;
        } else {
          this.selectedIndex--;
        }
        this.selectedItem = this.dataSource[this.selectedIndex];
        const item = this.listItems?.find(p => p.nativeElement.innerText === this.selectedItem[this.propertyName]);
        item?.nativeElement.scrollIntoView();
      }
    }
  }

  constructor(public elRef: ElementRef) {
    this.host = elRef;
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.host?.nativeElement?.focus();
  }

  onListItemSelected(event: MouseEvent, obj: any) {
    this.selectedItem = obj;
    this.onItemSelected.emit(obj);
  }

  focus() {
    this.host?.nativeElement?.focus();
    this.isFocused = true;

    setTimeout(() => {
      this.host?.nativeElement?.focus();
      this.isFocused = true;
    }, 2000);
  }
}
